type SentryInstance = {
    addBreadcrumb: (breadcrumb: any) => void;
    captureException: (err: any, options?: any) => void;
    captureMessage: (message: string, options?: any) => void;
};

const debug = typeof window !== 'undefined' && window.location.search.includes('laglog_debug');

export const createLogger = (sentryInstance: SentryInstance, errorSource: string) => {
    const debugLog = (...args: any[]) => {
        if (debug) {
            args.forEach(arg => {
                if (typeof arg === 'object') {
                    console.log(JSON.stringify(arg, null, 2));
                } else {
                    console.log(arg);
                }
            });
        }
    };

    /**
     * Capture error in Sentry with optional context message
     * @param err Error object or message
     * @param context Additional context string that will be visible in Sentry
     */
    const captureError = (err: any, context?: string) => {
        // Добавляем breadcrumb для контекста выполнения
        if (context) {
            sentryInstance.addBreadcrumb({
                category: 'error',
                message: context,
                level: 'error',
                timestamp: Date.now() / 1000
            });
        }

        sentryInstance.captureException(err, {
            // Extra data - видно в разделе "Additional Data" в Sentry
            extra: context ? {
                errorContext: context,
                timestamp: new Date().toISOString()
            } : undefined,
            // Tags - для фильтрации и группировки в Sentry UI
            tags: context ? {
                errorContext: context,
                errorSource
            } : undefined,
            level: 'error'
        });

        if (debug) {
            console.error(`${context || 'Unknown context'}: `, err);
        }
    };

    /**
     * Send a stable, searchable Sentry message event (not an exception) —
     * the repo convention for timeouts and other notable non-crash signals.
     */
    const captureMessage = (message: string, extra?: Record<string, unknown>) => {
        sentryInstance.captureMessage(message, {
            level: 'error',
            tags: { errorSource },
            extra
        });

        if (debug) {
            console.error(message, extra);
        }
    };

    return { debugLog, captureError, captureMessage };
};
